import React, {useEffect, useState} from 'react'
import { Selarti } from './components/selarti'
import { MainScreenV2 } from './components/main-screen-v2'
import { CrmsScreen } from '~/components/common/crms-screen'
import { BusinessProcessesV2 } from './components/business-processes-v2'
import { SellMoreScreen } from '~common/sell-more-screen'
import { SetupStepsScreen } from './components/setup-steps-screen'
import { SoftphoneScreen } from './components/softphone-screen'
import { ServicesScreenGroup } from './components/services-screen-group'
import { WhatLookOnpbx } from './components/what-look-onpbx'
import { AmplitudeCounter } from "~/amplitude-counter"
import { TelephonyCapabilities } from './components/telephony-capabilities'
import { SupportScreen } from './components/support-screen'
import { NumbersAndMinutesScreen } from "./components/numbers-and-minutes-screen";
import { PriceCalculateScreenV2 } from "~common/price-calculate-screen-v2";
import { FreePeriodScreenV2 } from "./components/free-period-screen-v2";
import { QuestionsScreenV2 } from "~common/questions-screen-v2";
import {priceService} from "~/store/price/price-service";
import {useAppSelector} from "~/hooks/redux";
import {OnlinepbxLoader} from "@onpbx/onlinepbx-components";

const IndexPage: React.FC = () => {
  const { country } = useAppSelector(state => state.countryReducer);
  useEffect(() => AmplitudeCounter('view_site', { 'country_site': country?.value.toLowerCase()}), [country?.value])
  const [isLegalPerson, setIsLegalPerson] = useState(false);
  const { data: services, isLoading } = priceService.useGetPricesQuery('');

  return (
      isLoading
          ? <OnlinepbxLoader/>
          : <>
      <MainScreenV2 />
      <CrmsScreen />
      <TelephonyCapabilities />
      <SupportScreen />
      <ServicesScreenGroup />
      <SetupStepsScreen />
      <QuestionsScreenV2 />
      <BusinessProcessesV2 />
      <FreePeriodScreenV2 />
      <SoftphoneScreen />
      <WhatLookOnpbx />
      <NumbersAndMinutesScreen />
      <PriceCalculateScreenV2
        services={services}
        isLegalPerson={isLegalPerson}
        setIsLegalPerson={setIsLegalPerson} />
      <SellMoreScreen />
    </>
  )
}

export { IndexPage }
